var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-block-editor date-formatter-chain" },
    [
      _c(
        "div",
        { staticClass: "editor-row customize-editor-minimize data-items" },
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v(_vm._s(_vm.$t("auto.dateFormatChainNumberFormatChains"))),
          ]),
          _vm._v(" "),
          _vm._l(_vm.clone.chains, function (item, index) {
            return _c("DateFormatItem", {
              key: index,
              attrs: {
                blockId: _vm.blockId,
                deleteEnabled: _vm.clone.chains.length > 1,
              },
              on: {
                delete: function () {
                  return _vm.deleteFormatter(index)
                },
              },
              model: {
                value: _vm.clone.chains[index],
                callback: function ($$v) {
                  _vm.$set(_vm.clone.chains, index, $$v)
                },
                expression: "clone.chains[index]",
              },
            })
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("SupsisButton", { on: { click: _vm.addItem } }, [
        _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.$t("auto.dateFormatChainAddNewFormatter"))),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }